(function () {

    'use strict';

    angular.module('FotocApp')

        .component('miniLayout', {

            template: '<svg viewBox="0 0 1000 1000"><rect  ng-repeat="b in $ctrl.bounds" ng-attr-height="{{b[3]}}" ng-attr-width="{{b[2]}}" ng-attr-y="{{b[1]}}" ng-attr-x="{{b[0]}}"/></svg>',
            bindings: {
                data: '<'
            },
            controller: function () {

                this.$onInit = function () {

                    if (angular.isDefined(this.data)) {
                        var first_size = Object.keys(this.data)[0];
                        this.bounds = this.data[first_size].bounds;
                    }


                }


                this.$onChanges = function () {
                    if (angular.isDefined(this.data)) {
                        var first_size = Object.keys(this.data)[0];
                        this.bounds = this.data[first_size].bounds;
                    }

                }

            }

        })

})();


